<main>
  <ngx-sonner-toaster duration="5000" offset="65px" position="top-right" />
  <app-shell-uif>
    <router-outlet />
  </app-shell-uif>
</main>
